import { all, put, takeLatest } from "redux-saga/effects";
import actions from "./action";
import { axiosGet } from "../axiosHelper";

export function* getRelationsRequest() {
  try {
    const { data } = yield axiosGet(`v1/lists/relations`);
    yield put(actions.getRelationsRequestSuccess(data));
  } catch (error) {
    yield put(actions.getRelationsRequestFailure());
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actions.GET_RELATIONS, getRelationsRequest)]);
}
